import { createContext, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { getToken } from "./authConfig";

export const UserRoleContext = createContext(null);

/**
 * Provider — place this once near the top of the app.
 * Fetches the role once per app load (in-memory only; cleared on page refresh).
 */
export const UserRoleProvider = ({ children }) => {  const [userRole, setUserRole] = useState(null); // null = loading

  useEffect(() => {
    const fetchRole = async () => {
      try {
        const token = await getToken();
        if (!token) { setUserRole("Member"); return; }

        const base64Url = token.split(".")[1];
        // eslint-disable-next-line prefer-regex-literals
        const base64 = base64Url.replaceAll("-", "+").replaceAll("_", "/");
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split("")
            .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
            .join("")
        );
        const decoded = JSON.parse(jsonPayload);
        const email = decoded.preferred_username || decoded.email || null;

        if (!email) { setUserRole("Member"); return; }

        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_API_URL}/api/users/`,
          { headers: { "oidc-token": token } }
        );
        const match = res.data.find(
          (u) => u.email.toLowerCase() === email.toLowerCase()
        );
        setUserRole(match?.role || "Member");
      } catch (err) {
        console.error("UserRoleProvider: failed to fetch role", err);
        setUserRole("Member");
      }
    };

    fetchRole();
  }, []);

  return (
    <UserRoleContext.Provider value={userRole}>
      {children}
    </UserRoleContext.Provider>
  );
};

UserRoleProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

/**
 * Hook — consume the role anywhere inside <UserRoleProvider>.
 * Returns null (loading), "Admin", or "Member".
 */
const useUserRole = () => useContext(UserRoleContext);

export default useUserRole;
